export function div(a, b) {
  return Math.floor(a / b)
}

export function mod(a, b) {
  return a % b
}

export async function handleNextChunks({
  pagination,
  pagesCount,
  requestNextChunkFn,
  shift,
  getExistingArticleIdsFn,
  articleIdField = 'id',
  setInProgressTrueFn = () => {},
  setInProgressFalseFn = () => {},
  setShiftFn,
  addNewArticlesFn
}) {
  const { take, page } = pagination
  let finalShift = shift
  let newArticlesLeftToAdd = take

  const shiftWithinChunk = mod(shift, take)
  const shiftWithinPages = div(shift, take)

  let lastItemExpectedIndex = shiftWithinChunk - 1
  let latestPage = page + shiftWithinPages

  if (latestPage >= pagesCount) {
    return finalShift
  }

  function createChunkRequestPromise(page) {
    return requestNextChunkFn({
      ...pagination,
      page
    })
  }

  function checkIfPageValid(page) {
    return page < pagesCount
  }

  function getCurrentShift({ chunkArticles, filteredChunkArticles }) {
    const existingIds = getExistingArticleIdsFn()
    const latestArticleId = existingIds[existingIds.length - 1]
    const lastItemActualIndex = chunkArticles.findIndex(
      article => article[articleIdField] === latestArticleId
    )
    const isChunkSufficientToFillRemaining =
      newArticlesLeftToAdd - filteredChunkArticles.length === 0

    const shiftIfLastItemFoundInChunk =
      lastItemActualIndex - lastItemExpectedIndex
    const shiftIfLastItemNotFoundInChunk = isChunkSufficientToFillRemaining
      ? 0
      : take

    return lastItemActualIndex >= 0
      ? shiftIfLastItemFoundInChunk
      : shiftIfLastItemNotFoundInChunk
  }

  function updateNewArticlesLeftToAdd({
    chunkArticles,
    filteredChunkArticles
  }) {
    newArticlesLeftToAdd -= filteredChunkArticles.length

    if (!chunkArticles.length) {
      newArticlesLeftToAdd = 0
    }
  }

  const firstChunkPromise = createChunkRequestPromise(latestPage)
  const chunkPromises = [firstChunkPromise]

  if (shiftWithinChunk > 0 && checkIfPageValid(latestPage + 1)) {
    const secondChunkPromise = createChunkRequestPromise(++latestPage)
    chunkPromises.push(secondChunkPromise)
  }

  while (newArticlesLeftToAdd > 0 && checkIfPageValid(latestPage)) {
    setInProgressTrueFn()

    if (!chunkPromises.length && checkIfPageValid(latestPage + 1)) {
      chunkPromises.push(createChunkRequestPromise(++latestPage))
    }

    const chunkResults = await Promise.all(chunkPromises)
    chunkPromises.length = 0
    const chunkArticles = chunkResults.flat()

    const existingIds = getExistingArticleIdsFn()
    const filteredChunkArticles = chunkArticles
      .filter(article => !existingIds.includes(article[articleIdField]))
      .slice(0, newArticlesLeftToAdd)

    finalShift += getCurrentShift({
      chunkArticles,
      filteredChunkArticles
    })
    lastItemExpectedIndex = -1

    await addNewArticlesFn(filteredChunkArticles)
    updateNewArticlesLeftToAdd({ chunkArticles, filteredChunkArticles })

    setInProgressFalseFn()
  }

  setShiftFn(finalShift)
}
